import { __styles } from '@griffel/react';
import { typographyStyles } from '@fluentui/react-theme';
export const subtitle2ClassNames = {
  root: 'fui-Subtitle2'
};
/**
 * Styles for the root slot
 */
export const useSubtitle2Styles = /*#__PURE__*/__styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fod5ikn",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "faaz57k"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".fod5ikn{font-size:var(--fontSizeBase400);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".faaz57k{line-height:var(--lineHeightBase400);}"]
});